module.exports = __webpack_public_path__ + "fonts/Aeonik-RegularItalic.30f870d.woff";